// ============================================================================
// Flow Button Types
// ============================================================================

export type FlowType = 'docflow' | 'part_create' | 'bom_maintain' | 'purchase_order' | 'sale_order' | 'invoice_process' | 'batch_invoice_process';

export type FlowButtonShape = 'circle' | 'square' | 'pill' | 'rounded-rect';

export type FlowButtonColor = 'blue' | 'emerald' | 'amber' | 'rose' | 'purple' | 'cyan' | 'gray';

export interface IFlowButton {
  id: string;
  name: string;
  subtitle?: string;
  flow_type: FlowType;
  flow_config: Record<string, unknown>;
  shape: FlowButtonShape;
  icon: string;
  color: FlowButtonColor;
  page: string;
  created_by: string;
  enabled: boolean;
  created_at: string;
  updated_at: string;
}

export interface IFlowButtonCreateRequest {
  name: string;
  subtitle?: string;
  flow_type: FlowType;
  flow_config?: Record<string, unknown>;
  shape?: FlowButtonShape;
  icon?: string;
  color?: FlowButtonColor;
  page?: string;
}

export interface IFlowButtonUpdateRequest {
  name?: string;
  subtitle?: string;
  flow_type?: FlowType;
  flow_config?: Record<string, unknown>;
  shape?: FlowButtonShape;
  icon?: string;
  color?: FlowButtonColor;
  page?: string;
  enabled?: boolean;
}

// ============================================================================
// Flow Handler Interface
// ============================================================================

export interface FlowResult {
  status: 'success' | 'error' | 'navigate';
  message?: string;
  navigateTo?: string;
}

export type FlowButtonState =
  | { status: 'idle' }
  | { status: 'menu' }
  | { status: 'active'; action: string }
  | { status: 'locked_elsewhere' }
  | { status: 'success' }
  | { status: 'error'; message: string };

// ============================================================================
// Flow Type Display Config
// ============================================================================

export const FLOW_TYPE_LABELS: Record<FlowType, { en: string; zh: string }> = {
  docflow: { en: 'DocFlow Extraction', zh: '文件流程' },
  part_create: { en: 'Part Creation', zh: '零件建立' },
  bom_maintain: { en: 'BOM Maintenance', zh: 'BOM維護' },
  purchase_order: { en: 'Purchase Order', zh: '採購單' },
  sale_order: { en: 'Sale Order', zh: '銷售單' },
  invoice_process: { en: 'Invoice Process', zh: '發票處理' },
  batch_invoice_process: { en: 'Batch Invoice', zh: '批次發票處理' },
};

export const FLOW_BUTTON_COLORS: Record<FlowButtonColor, { bg: string; text: string; border: string; ring: string }> = {
  blue:    { bg: 'bg-blue-500',    text: 'text-white', border: 'border-blue-600',    ring: 'ring-blue-300' },
  emerald: { bg: 'bg-emerald-500', text: 'text-white', border: 'border-emerald-600', ring: 'ring-emerald-300' },
  amber:   { bg: 'bg-amber-500',   text: 'text-white', border: 'border-amber-600',   ring: 'ring-amber-300' },
  rose:    { bg: 'bg-rose-500',    text: 'text-white', border: 'border-rose-600',    ring: 'ring-rose-300' },
  purple:  { bg: 'bg-purple-500',  text: 'text-white', border: 'border-purple-600',  ring: 'ring-purple-300' },
  cyan:    { bg: 'bg-cyan-500',    text: 'text-white', border: 'border-cyan-600',    ring: 'ring-cyan-300' },
  gray:    { bg: 'bg-gray-500',    text: 'text-white', border: 'border-gray-600',    ring: 'ring-gray-300' },
};
